/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconFolder8 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconFolder8(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 8 8" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.724 2.333h1.61c.32 0 .526 0 .684.011.152.01.21.029.237.04a.667.667 0 0 1 .361.36c.012.029.03.087.04.239.01.157.011.364.011.684v1c0 .32 0 .526-.011.684a.773.773 0 0 1-.04.237.667.667 0 0 1-.36.361.773.773 0 0 1-.238.04c-.158.01-.365.011-.684.011H2.667c-.32 0-.526 0-.684-.011a.773.773 0 0 1-.238-.04.667.667 0 0 1-.36-.36.773.773 0 0 1-.04-.238c-.011-.158-.011-.365-.011-.684V3c0-.32 0-.526.01-.684a.773.773 0 0 1 .04-.238.667.667 0 0 1 .361-.36.774.774 0 0 1 .238-.04c.158-.011.364-.011.684-.011h.39l.667.666ZM3.334 1h-.667c-.621 0-.932 0-1.177.101a1.333 1.333 0 0 0-.722.722C.667 2.068.667 2.38.667 3v1.667c0 .62 0 .932.101 1.177.136.326.395.586.722.721.245.102.556.102 1.177.102h2.667c.62 0 .932 0 1.177-.102.326-.135.586-.395.721-.721.102-.245.102-.556.102-1.177v-1c0-.622 0-.932-.102-1.177a1.333 1.333 0 0 0-.721-.722c-.245-.101-.556-.101-1.177-.101H4L3.334 1Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconFolder12 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconFolder12(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 12 12" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.586 3.5H8c.48 0 .79 0 1.026.017.228.015.315.042.357.06a1 1 0 0 1 .54.54c.018.042.045.129.06.357C10 4.71 10 5.02 10 5.5V7c0 .48 0 .79-.017 1.026-.015.228-.042.315-.06.357a1 1 0 0 1-.54.54c-.042.018-.129.045-.357.06C8.79 9 8.48 9 8 9H4c-.48 0-.79 0-1.026-.017-.228-.015-.315-.042-.357-.06a1 1 0 0 1-.54-.54c-.018-.042-.045-.129-.06-.357A16.911 16.911 0 0 1 2 7V4.5c0-.48 0-.79.017-1.026.015-.228.042-.315.06-.357a1 1 0 0 1 .54-.54c.042-.018.129-.045.357-.06C3.21 2.5 3.52 2.5 4 2.5h.586l1 1ZM5 1.5H4c-.932 0-1.398 0-1.765.152a2 2 0 0 0-1.083 1.083C1 3.102 1 3.568 1 4.5V7c0 .932 0 1.398.152 1.765a2 2 0 0 0 1.083 1.083C2.602 10 3.068 10 4 10h4c.932 0 1.398 0 1.765-.152a2 2 0 0 0 1.083-1.083C11 8.398 11 7.932 11 7V5.5c0-.932 0-1.398-.152-1.765a2 2 0 0 0-1.083-1.083C9.398 2.5 8.932 2.5 8 2.5H6l-1-1Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconFolder16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconFolder16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.447 4.667h3.22c.639 0 1.052 0 1.368.022.304.02.42.056.475.08.327.134.586.394.722.72.023.056.058.172.079.476.021.316.022.729.022 1.368v2c0 .64 0 1.053-.022 1.369-.021.304-.056.42-.08.475a1.333 1.333 0 0 1-.721.722c-.056.023-.171.058-.475.079-.316.021-.73.022-1.369.022H5.333c-.64 0-1.052 0-1.368-.022-.304-.021-.42-.056-.476-.08a1.333 1.333 0 0 1-.721-.721c-.023-.056-.059-.171-.08-.475a22.55 22.55 0 0 1-.022-1.369V6c0-.64.001-1.052.023-1.368.02-.304.056-.42.079-.476.135-.326.395-.586.721-.721.056-.023.172-.059.476-.08.316-.02.729-.022 1.368-.022h.781l1.333 1.334ZM6.667 2H5.332c-1.243 0-1.864 0-2.354.203-.653.27-1.172.79-1.443 1.443-.203.49-.203 1.111-.203 2.354v3.333c0 1.243 0 1.864.203 2.354.27.654.79 1.173 1.443 1.443.49.203 1.111.203 2.354.203h5.333c1.243 0 1.864 0 2.354-.203a2.667 2.667 0 0 0 1.443-1.443c.203-.49.203-1.111.203-2.354v-2c0-1.242 0-1.863-.203-2.353a2.667 2.667 0 0 0-1.443-1.444c-.49-.203-1.111-.203-2.354-.203H8L6.666 2Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconFolder20 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconFolder20(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 20 20" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.31 5.833h4.024c.799 0 1.315.001 1.71.028.38.026.525.07.594.1.409.168.733.493.902.901.029.07.073.214.1.594.026.395.027.911.027 1.71v2.5c0 .8 0 1.316-.028 1.711-.026.38-.07.525-.099.594-.169.409-.493.733-.902.902-.07.029-.214.073-.594.1-.395.026-.911.027-1.71.027H6.667c-.8 0-1.315 0-1.71-.028-.38-.026-.525-.07-.594-.099a1.666 1.666 0 0 1-.902-.902c-.03-.07-.074-.214-.1-.594-.026-.395-.027-.911-.027-1.71V7.5c0-.8 0-1.315.028-1.71.025-.38.07-.525.099-.594.169-.409.493-.733.902-.902.069-.03.214-.074.594-.1.395-.026.91-.027 1.71-.027h.976L9.31 5.833ZM8.334 2.5H6.667c-1.553 0-2.33 0-2.942.254A3.333 3.333 0 0 0 1.92 4.558c-.254.612-.254 1.389-.254 2.942v4.167c0 1.553 0 2.33.254 2.942a3.333 3.333 0 0 0 1.804 1.804c.612.254 1.389.254 2.942.254h6.667c1.553 0 2.33 0 2.942-.254a3.333 3.333 0 0 0 1.804-1.804c.254-.613.254-1.39.254-2.942v-2.5c0-1.553 0-2.33-.254-2.943a3.333 3.333 0 0 0-1.804-1.804c-.613-.253-1.39-.253-2.942-.253H10L8.334 2.5Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconFolder24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconFolder24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.172 7H16c.96 0 1.578.001 2.052.033.457.032.63.085.713.12a2 2 0 0 1 1.083 1.082c.034.083.088.257.119.713C19.999 9.42 20 10.04 20 11v3c0 .96-.001 1.579-.033 2.052-.031.457-.085.63-.12.713a2 2 0 0 1-1.082 1.083c-.083.034-.256.088-.713.119-.474.032-1.093.033-2.052.033H8c-.96 0-1.579-.001-2.052-.033-.456-.031-.63-.085-.713-.12a2 2 0 0 1-1.083-1.082c-.034-.083-.087-.256-.119-.713C4.001 15.58 4 14.96 4 14V9c0-.96.001-1.579.033-2.052.032-.456.085-.63.12-.713a2 2 0 0 1 1.082-1.083c.083-.034.257-.087.713-.119C6.42 5.001 7.04 5 8 5h1.172l2 2ZM10 3H8c-1.864 0-2.796 0-3.53.304A4 4 0 0 0 2.303 5.47C2 6.204 2 7.136 2 9v5c0 1.864 0 2.796.304 3.53a4 4 0 0 0 2.165 2.165C5.204 20 6.136 20 8 20h8c1.864 0 2.796 0 3.53-.305a4 4 0 0 0 2.165-2.164C22 16.796 22 15.864 22 14v-3c0-1.864 0-2.796-.305-3.53a4 4 0 0 0-2.164-2.166C18.796 5 17.864 5 16 5h-4l-2-2Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconFolder = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconFolder(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '8':
            return <IconFolder8 {...iconProps} />;
        case '12':
            return <IconFolder12 {...iconProps} />;
        case '16':
            return <IconFolder16 {...iconProps} />;
        case '20':
            return <IconFolder20 {...iconProps} />;
        case '24':
            return <IconFolder24 {...iconProps} />;
        default:
            return <IconFolder24 {...iconProps} />;
    }
});
